import React from "react";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import "./Campus.css";
import { notify } from "react-notify-toast";
import Modal from "../../Components/Modal/Modal";
import TimePicker from '@bit/nexxtway.react-rainbow.time-picker';
import { connect } from "react-redux";
import { createClass, updateClass, deleteClass } from "../../redux/college/college.actions";
import { API } from "../../API";
import { getClass } from "../../Helper";
import { getClassCategories } from "../../Helper";
import { Placeholder } from "semantic-ui-react";
import FilterAccordion from "../../Components/SearchTeacherFilter/CollapseFilter2";
import Spinner from "../../Components/Spinner/Spinner";
import { Alert } from "@mui/material";
import UnstyledSelectIntroduction from "../../Components/custom-mui/Selection";
import NumberInput from "../../Components/custom-mui/InputNumberSimple";
import EcecFilterAccordion from "../../Components/SearchTeacherFilter/EcecCollapseFilter";
const moment = require("moment")
const _ = require('lodash')

const classListFull = getClass(true);
// const vocationalCoursesList = getClassCategories()

const paidMinuteButtonStyle = {
  minWidth: "80px",
  width: "100%"
}

const campusButtonStyle = {
  minWidth: "320px"
}

class TimetableForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      _qualificationExpanded: true,
      _trainingPackageExpanded: true,
      vetcValues: [],
      subLevelsList: [],
      up: true,
      // classes: [],
      current_class: "ELICOSGE",
      department: "ELICOSGE",
      session: "",
      level: [],
      paid_teaching_hours: 0,
      days_of_delivery: "",
      /* canViewXXX is for display/not display the class level related to that department*/
      canViewElicosGE: true,
      canViewElicosEP: false,
      canViewElicosO: false,
      canViewVetE: false,
      canViewVetC: false,
      canViewSubLevelsOfVetC: false,
      vet_level_select: "",
      // campuses: [],
      inst: null,
      arrival_time: '',
      start_time: '',
      finish_time: '',
      reference_name: '',
      class_campus_id: null,
      class_campus: null,
      class_note: '',
      class_id: '',
      allClasses: props.classes,
      isShowing: false,
      newClasses: [],
      mobileCla: props.mobileCla,
      customer: '',
      activecampuses: [],
      fullcontrol: false,
      hourly_rate: 0,
      edited: false,
      selectedByQualification: {},
      qualificationList: [],
      expired_time: '',
      showUnsavedPopup: false,
      moveToTag: null,
      paid_hour: null,
      paid_minute: null
      // isShowVETFee: false,
			// hourly_rate_option: 'default',
			// hourly_rate_number: 55
    }
    // if (!props.user) {
    //   window.location = "/login"
    // }
    API.getQualificationList().then(result => {
      
      const qualifications = result?.data?.data
      // get all level of VET
      let levels = []
      let levelPriorities = []
      qualifications.filter(item => item.type === 'vet').forEach((item => {
				const subQualifications = item.qualifications
				subQualifications.forEach(ele => {
					if (!levels.includes(ele.level) && ele.level?.length) {
						levels.push(ele.level)
						levelPriorities.push({
							name: ele.level,
							priority: ele.priority
						})
					}
					else if(levels.includes(ele.level) && ele.level?.length && ele.priority) {
						const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
						levelPriorities = [
						  ...levelPriorities.slice(0, itemIndex),
						  {
							name: ele.level,
							priority: ele.priority
						  },
						  ...levelPriorities.slice(itemIndex + 1)
						]
					}
				})
			}))

      levels.sort((a, b) => {
        const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
        const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
        return priorityA - priorityB;
      })

      this.setState({
        qualificationList: qualifications,
        vetLevels: levels
      })
    })
  }

  setShowUnsavedPopup = (isShow) => {
    this.setState({
      showUnsavedPopup: isShow
    })
  }

  componentWillReceiveProps(props) {
    // console.log(props.duplicatedTimetable)
    if (props.duplicatedTimetable) {
      const modifiedLevel = props.duplicatedTimetable.level.forEach((item, index) => {
        if (item.includes(" GE")) {
          props.duplicatedTimetable.level[index] = item.replace("GE", "").trim()
        }
      })
      const paid_hour = Math.floor(props.duplicatedTimetable.paid_teaching_hours)
      const paid_minute = Math.round((props.duplicatedTimetable.paid_teaching_hours - paid_hour) * 60)
      this.setState({
        department: props.duplicatedTimetable.department,
        level: props.duplicatedTimetable.level,
        campus_id: props.duplicatedTimetable.class_campus_id,
        session: props.duplicatedTimetable.session,
        days_of_delivery: props.duplicatedTimetable.days_of_delivery,
        arrival_time: props.duplicatedTimetable.arrival_time,
        start_time: props.duplicatedTimetable.start_time,
        end_time: props.duplicatedTimetable.end_time,
        paid_teaching_hours: props.duplicatedTimetable.paid_teaching_hours,
        class_note: props.duplicatedTimetable.class_note,
        reference_name: 'New',
        inst_shortname: props.duplicatedTimetable.class_campus.inst_shortname,
        // inst_id: props.duplicatedTimetable.institution._id,
        hourly_rate: props.duplicatedTimetable.hourly_rate,
        selected_levels: props.duplicatedTimetable.selected_levels || [],
        expired_time: props.duplicatedTimetable.expired_time || '',
        paid_hour,
        paid_minute
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.qualificationList?.length && prevState.qualificationList?.length === 0) {
      this.getCampuses()
    }
  }

  getCampuses = () => {
    const { campuses } = this.props;
    if (this.state.mobileCla) {
      this.setFieldsValue(this.state.mobileCla)
    } else {
      var cids = []
      for (var i = 0; i < campuses.length; i++) {
        cids.push(campuses[i]._id)
      }
      this.getClasses(cids)
    }
  }

  getClasses = (cids) => {
    var index = 0
    if (localStorage.getItem('timetable-Index') != null) {
      index = parseInt(localStorage.getItem('timetable-Index'))
    }
    localStorage.setItem('timetable-Index', index);
    this.swapTab(index)
  }

  getInstMember = () => {
    const memberList = [... this.props.personnels]
    memberList.push(this.props.user)
    const member = memberList.find(ele => 
      ele._id?.toString() === this.state.created_by?.toString() ||
      ele.customer_id?.toString() === this.state.created_by?.toString()
    )
    return member
  }


  addNewClass = () => {
    // console.log('inst', this.props.institution, this.props.campuses[0]._id)
    if (this.props.campuses === 'undefined' || this.props.campuses.length === 0) {
      notify.show('Please complete Campus screen first before this screen')
    } else {
      API.createClass({
        campus_id: this.props.campuses[0]._id,
        inst_shortname: this.props.institution.inst_shortname,
        inst_id: this.props.institution._id,
      }).then((res) => {
        var temp = this.state.newClasses
        temp.push(res.data)
        this.setState({
          newClasses: temp,
          current_class: res.data,
        }, () => {
          // console.log('new created', res.data)
          this.setFieldsValue(res.data)
          this.props.createClass(res.data)
          // const msg = "Class created successfully";
          // notify.show(msg);
        })
      })
    }
  }

  handleDeleteClass = (e) => {
    this.props.deleteClass(this.state.current_class);
    this.setState({ isShowing: false });
    localStorage.setItem('timetable-Index', 0);
    window.location.reload();
  };

  setFieldsValue = (current_class) => {
    if (this.state.mobileCla) {
      current_class = this.state.mobileCla
    }

    if (current_class) {

      if (current_class.department === "ELICOSGE") {
        this.setState({
          department: "ELICOSGE",
          canViewElicosGE: true,
          canViewElicosEP: false,
          canViewElicosO: false,
          canViewVetE: false,
          canViewVetC: false,
          canViewSubLevelsOfVetC: false
        })
      } else if (current_class.department === "ELICOS_Exam_Preparation") {
        this.setState({
          department: "ELICOS_Exam_Preparation",
          canViewElicosGE: false,
          canViewElicosEP: true,
          canViewElicosO: false,
          canViewVetE: false,
          canViewVetC: false,
          canViewSubLevelsOfVetC: false
        })
      } else if (current_class.department === "ELICOS_Other") {
        this.setState({
          department: "ELICOS_Other",
          canViewElicosGE: false,
          canViewElicosEP: false,
          canViewElicosO: true,
          canViewVetE: false,
          canViewVetC: false,
          canViewSubLevelsOfVetC: false
        })
      } else if (current_class.department === "VETE") {
        this.setState({
          department: "VETE",
          canViewElicosGE: false,
          canViewElicosEP: false,
          canViewElicosO: false,
          canViewVetE: true,
          canViewVetC: false,
          canViewSubLevelsOfVetC: false
        })
      }
      else if (current_class.department === "VETC") {
        this.setState({
          department: "VETC",
          canViewElicosGE: false,
          canViewElicosEP: false,
          canViewElicosO: false,
          canViewVetE: false,
          canViewVetC: true,
        })
      }


      
      // current_class.level.forEach((item, index) => {
      //   if (item.includes(" GE")) {
      //     current_class.level[index] = item.replace("GE", "").trim()
      //   }
      // })
      
      const level = current_class.level;
      const selected_levels = current_class.selected_levels
      const paid_teaching_hours = current_class.paid_teaching_hours;
      const days_of_delivery = current_class.days_of_delivery;
      const hourly_rate = current_class.hourly_rate ? current_class.hourly_rate:50.85;

      const arrival_time = this.timeFormat(current_class.arrival_time);
      const start_time = this.timeFormat(current_class.start_time);
      const end_time = this.timeFormat(current_class.end_time);

      const class_note = current_class.class_note;
      const class_id = current_class._id;
      const expired_time = current_class.expired_time 
        ? new Date(current_class.expired_time).toISOString().split('T')[0]
        : null
      const created_by = current_class.created_by
      const created_by_role = current_class.created_by_role

      

      const class_campus_id = current_class.campus_id;
			let class_campus = null

      for (let i = 0; i < this.props.campuses.length; i++) {
        if (this.props.campuses[i]._id === class_campus_id) {
					class_campus = this.props.campuses[i]
          //break
        }
      }
      const reference_name = current_class.reference_name;
      let session = null;
      if (current_class.session === 1 || current_class.session === "1") {
        session = "morning"
      } else if (current_class.session === 2 || current_class.session === "2") {
        session = "afternoon"
      } else if (current_class.session === 3 || current_class.session === "3") {
        session = "evening"
      } else if (current_class.session === 4 || current_class.session === "4") {
        session = "all_day"
      }
      // var session = classes.session;
      const selectedByQualification = {}
      const selectedLevels = current_class.selected_levels
      const qualifications = this.state.qualificationList || []

      qualifications.filter(item => item.type === 'vet').forEach((item => {
				const subQualifications = item.qualifications
				subQualifications.forEach(ele => {
          const { units } = ele
          units.forEach(unit => {
            if(selectedLevels.includes(unit._id)) {
              if(selectedByQualification[ele._id]?.length) {
                selectedByQualification[ele._id].push(unit._id)
              }
              else {
                  selectedByQualification[ele._id] = [unit._id]
              }
            }
          })
				})
			}))

      // calculate paid hour to minute and hour
      const paid_hour = Math.floor(paid_teaching_hours);
      const paid_minute = Math.round((paid_teaching_hours - paid_hour) * 60);

      this.setState({
        current_class,
        // department,
        session, level, paid_teaching_hours, days_of_delivery
        , arrival_time, start_time, end_time, reference_name,
        class_campus_id, class_note, class_id, hourly_rate, selected_levels, selectedByQualification,
        expired_time: expired_time || '',
        created_by: created_by || null,
        created_by_role: created_by_role || '',
				class_campus,
        paid_hour, paid_minute
      });

      // auto-select vet category depending on what levels are set for the class
      let vet_level_select = "bsb"

      for (let lvl of level) {
        let cl = classListFull.find(c => {
          return c.key === lvl && (
            c.type.includes("bsb") ||
            c.type.includes("chc") ||
            c.type.includes("fns") ||
            c.type.includes("fsk") ||
            c.type.includes("shb") ||
            c.type.includes("ict") ||
            c.type.includes("sit") ||
            c.type.includes("cua")
          )
        })
        if (cl) {
          vet_level_select = cl.type[0]
          break;
        }
      }
      this.setState({ vet_level_select })
    }

  }

  swapTabWithConfirm = (key) => {
    if(this.state.edited) {
      this.setState({
        showUnsavedPopup: true,
        moveToTag: key
      })
    }
    else {
      this.setState({
        moveToTag: key
      })
      this.swapTab(key)
    }
  }

  swapTab = (key) => {
    if (key === 'addNew') {
      localStorage.setItem('timetable-Index', 0);
      this.addNewClass()
    } else if (key === 'default') {
      const current_class = this.props.classes[0]
      this.setState({
        current_class: current_class,
      }, () => {
        this.setFieldsValue(current_class)
      })
    } else {
      for (let i = 0; i < this.props.classes.length; i++) {
        if (this.props.classes[i]._id === key || i === key) {
          localStorage.setItem('timetable-Index', i);
          const current_class = this.props.classes[i]
          this.setState({
            current_class: current_class,
          }, () => {
            this.setFieldsValue(current_class)
          })
          break
        }
      }
    }
  }

  componentDidMount = () => {
    this.getCampuses()
    //this.swapTab('default')
    this.setState({
      activecampuses: this.props.campuses.map((campus) => campus._id),
      fullcontrol: this.props.user.permissions ? false : true,
    })
    // console.log('after mounting component', this.setState.fullcontrol)
  }

  timeFormat = (old_time) => {
    var new_time = ''
    var olt = old_time.split(":")
    if (olt[0].length === 1) {
      new_time = '0' + olt[0]
    } else {
      new_time = olt[0]
    }
    new_time += ":"
    new_time += olt[1]

    return new_time
  }

  handleRadioChange = (e) => {
    // console.log(
    //     "aaaaaaaaaaa: ",e.target.name," ",e.target.value," ",e.target.title," ",e.target.checked,"",e.target.id
    // )
    this.setState({ [e.target.name]: e.target.title })
  }

  handleSessionChange = (e) => {
    this.setState({
      session: e.target.title,
      edited: true
    })
  }

  handleLevelChange = (e, qua, rootID = null) => {
    console.log("handleLevelChange: ", qua, rootID)
    this.setState({ edited: true });
    let selected_levels = [...this.state.selected_levels];
    this.state.subLevelsList = []
    let selectedByQualificationNew = {
      ...this.state.selectedByQualification
    }
    if (e.target.checked) {
      selected_levels.push(e.target.value)
      if(e.target.value === rootID) {
        if(qua?._id) {
          if(selectedByQualificationNew?.[qua._id]) {
            selected_levels = selected_levels.filter(lv => !selectedByQualificationNew?.[qua._id]?.includes(lv))
          }
          selectedByQualificationNew[qua._id] = [e.target.value]
        }
      }
      else {
        selected_levels = selected_levels.filter(lv => lv !== rootID);
        if(qua?._id) {
          if(selectedByQualificationNew[qua._id]) {
            selectedByQualificationNew[qua._id] = [
              ...selectedByQualificationNew[qua._id],
              e.target.value
            ]?.filter(ele => ele !== rootID)
          }
          else {
            selectedByQualificationNew[qua._id] = [e.target.value]
          }
        }
      }
      this.setState({ selected_levels })
    } else {
      // const splitValue = e.target.value.split("_id:")?.[0]
      selected_levels = selected_levels.filter(lv => lv !== e.target.value);
      if(qua?._id && selectedByQualificationNew?.[qua._id]) {
        selectedByQualificationNew[qua._id] = selectedByQualificationNew[qua._id].filter(lv => lv !== e.target.value)
      }
      this.setState({ selected_levels })
    }

    this.setState({
      selectedByQualification: selectedByQualificationNew
    })
    this.state.subLevelsList = classListFull.filter(cl => cl.type.includes(e.target.value))

    // const isIncludingVETCourse = _.flatten(Object.values(selectedByQualificationNew))?.length
    // if(isIncludingVETCourse) {
    //   if(!this.state.isShowVETFee) {
    //     this.setState({isShowVETFee: true})
    //   }
    // }
    // else {
    //   if(this.state.isShowVETFee) {
    //     this.setState({isShowVETFee: false})
    //   }
    // }

    // console.log("modified: ", this.state.isShowVETFee, selectedByQualificationNew)
  }

  handleViewElicosGE = (e) => {
    this.setState({
      // level: [],
      department: e.target.title,
      canViewElicosGE: true,
      canViewElicosEP: false,
      canViewElicosO: false,
      canViewVetE: false,
      canViewVetC: false,
      canViewSubLevelsOfVetC: false,
      edited: true
    })
  }
  handleViewElicosEP = (e) => {
    this.setState({
      // level: [],
      department: e.target.title,
      canViewElicosEP: true,
      canViewElicosGE: false,
      canViewElicosO: false,
      canViewVetE: false,
      canViewVetC: false,
      canViewSubLevelsOfVetC: false,
      edited: true
    })
  }
  handleViewElicosO = (e) => {
    this.setState({
      // level: [],
      department: e.target.title,
      canViewElicosO: true,
      canViewElicosGE: false,
      canViewElicosEP: false,
      canViewVetE: false,
      canViewVetC: false,
      canViewSubLevelsOfVetC: false,
      edited: true
    })
  }
  handleViewVetE = (e) => {
    this.setState({
      // level: [],
      department: e.target.title,
      canViewElicosEP: false,
      canViewElicosGE: false,
      canViewElicosO: false,
      canViewVetE: true,
      canViewVetC: false,
      canViewSubLevelsOfVetC: false,
      edited: true
    })
  }
  handleViewVetC = (e) => {
    this.setState({
      // level: [],
      department: e.target.title,
      canViewElicosEP: false,
      canViewElicosGE: false,
      canViewElicosO: false,
      canViewVetE: false,
      canViewVetC: true,
      edited: true
    })
  }

  validate = (session) => {
    let valid = true
    if (this.state.selected_levels.length === 0) {
      valid = false
      notify.show("Please select at least one Course/Class Type or Qualification from the dropdown.")
    } else if (session === 0) {
      valid = false
      notify.show("Please select at least one session for the class.")
    } else if (this.state.arrival_time === ':undefined') {
      valid = false
      notify.show("Please set the arrival time for the class.")
    } else if (this.state.start_time === ':undefined') {
      valid = false
      notify.show("Please set the start time for the class.")
    } else if (this.state.end_time === ':undefined') {
      valid = false
      notify.show("Please set the end time for the class.")
    } else if (this.state.paid_hour.toString() === '' ||
      this.state.paid_hour < 3) {
      valid = false
      notify.show("Please enter the paid teaching hours (>= 3) for the class.")
    } else if (this.state.days_of_delivery === '') {
      valid = false
      notify.show("Please enter days of delivery")
    } else if (this.state.paid_hour > 10) {
      valid = false
      notify.show("The teaching hours per day should not exceed 10 hours.")
    }
    return valid
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.department) {
      var session = 0
      switch (this.state.session) {
        case 'morning':
          session = 1
          break;
        case 'afternoon':
          session = 2
          break;
        case 'evening':
          session = 3
          break;
        case 'all_day':
          session = 4
          break;
        default:
          break;
      }
      const valid = this.validate(session)
      if (valid) {
        const newData = {
          department: this.state.department,
          level: this.state.level,
          campus_id: this.props?.duplicatedTimetable?.class_campus_id || this.state.class_campus_id,
          session: session,
          days_of_delivery: this.state.days_of_delivery,
          arrival_time: this.state.arrival_time + ":00",
          start_time: this.state.start_time + ":00",
          end_time: this.state.end_time + ":00",
          paid_teaching_hours: this.state.paid_hour + this.state.paid_minute/60,
          class_note: this.state.class_note,
          class_id: this.state.class_id,
          reference_name: this.state.reference_name,
          inst_shortname: this.state.class_campus.inst_shortname,
          inst_id: this.props.institution._id,
          hourly_rate: this.state.hourly_rate,
          selected_levels: this.state.selected_levels,
          expired_time: this.state.expired_time !== '' ? this.state.expired_time : null
        }
        console.log("Submit class: ", newData)

        if (this.props?.duplicatedTimetable?.is_duplicate) {
          newData.is_duplicate = true
        }

        this.props.updateClass(this.state.class_id, newData);
        // API.instProgressEmail({
        //   inst_id: this.props.institution._id,
        //   email_address: this.props.user.email,
        //   etype: "TT_CONF",
        // })
        setTimeout(window.location.reload.bind(window.location), 1500);
      }
      this.props.updateTabPairs();
    } else {
      console.log('No department selected', this.state.department)
      notify.show("Please select a department.")
    }
  }

  handleCampusChange = (e, value) => {
		console.log("handleCampusChange: ", value)
    this.setState({ edited: true });
    for (var i = 0; i < this.props.campuses.length; i++) {
      if (this.props.campuses[i]._id === value) {
				console.log("setState: ", {
          class_campus_id: value,
          class_campus: this.props.campuses[i],
        })
        this.setState({
          class_campus_id: value,
          class_campus: this.props.campuses[i],
        })
      }
    }
  }

  handleDaysChange = (e) => {
    this.setState({ edited: true });
    if (this.state.days_of_delivery.includes(e.target.title)) {
      var dod = this.state.days_of_delivery.split(",");
      dod.splice(dod.indexOf(e.target.title), 1)
      const new_dod = dod.toString()
      this.setState({
        days_of_delivery: new_dod,
      })
    } else {
      var dod = this.state.days_of_delivery.split(",");
      dod.push(e.target.title)
      const new_dod = dod.toString()
      this.setState({
        days_of_delivery: new_dod,
      })
    }
  }

  handlePHchange = (e) => {
    this.setState({
      paid_teaching_hours: e.target.value,
      edited: true
    })
  }

  handleCNchange = (e) => {
    this.setState({
      class_note: e.target.value,
      edited: true
    })
  }

  handleHRchange = (e)=>{
    this.setState({
      hourly_rate:e.target.value
    })
  }

  handleRNchange = (e) => {
    this.setState({
      reference_name: e.target.value,
      edited: true
    })
  }

  handleExpiredTimeChange = (e) => {
    this.setState({
      expired_time: e.target.value,
      edited: true
    })
  }


  openModal = (e) => {
    this.setState({ isShowing: true });
  }
  closeModal = (e) => {
    this.setState({ isShowing: false });
  }

  defaultCampus = () => {
    var default_campus = <option value="1" hidden>
      Select from drop down
    </option>
    if (this.state.class_campus != null) {
      default_campus = <option selected value={this.state.class_campus._id} key={this.state.class_campus._id} hidden>
        {this.state.class_campus.address_line1 +
        // (this.state.class_campus.address_line2 ? ', ' + this.state.class_campus.address_line2 : '') +
        (this.state.class_campus.suburb ? ', ' + this.state.class_campus.suburb : '')}
      </option>
    } else {
      for (var i = 0; i < this.props.campuses.length; i++) {
        if (this.state.current_class?.campus_id === this.props.campuses[i]) {
          default_campus = <option value={this.props.campuses[i]._id} key={this.props.campuses[i]._id} hidden>
            {this.props.campuses[i].address_line1 +
            // (this.props.campuses[i].address_line2 ? ', ' + this.props.campuses[i].address_line2 : '')
            (this.props.campuses[i].suburb ? ', ' + this.props.campuses[i].suburb : '')}
          </option>
          break
        }
      }
    }

    return default_campus
  }

  getNumberOfBookingForCurrentClass = () => {
    const numberOfBooking = this.props.bookingCount?.find(ele => 
      ele?._id?.toString() === this.state?.current_class?._id?.toString()
    )?.count || 0
    return numberOfBooking
  }

	handleHourlyRateOptionChange = (e, value) => {
		console.log("handleHourlyRateChange: ", e.target.value, value)
		this.setState({
			hourly_rate_option: value,
			edited: true
		})
	}

	handleHourlyRateChange = (e) => {
		console.log("handleHourlyRateChange: ", e.target.value)
		this.setState({
			hourly_rate_number: e.target.value,
			edited: true
		})
	}

  onPaidHourChange = (e, value, key) => {
    e.preventDefault()
    console.log("onPaidHourChange: ", key, value)
    if(key === 'hour') {
      if(+value > 0) {
        this.setState({
          paid_hour: value,
          edited: true
        })
      }
      else {
        return;
        // notify.show("Invalid paid hour number")
      }
    }
    else {
      if([0, 15, 30, 45].includes(+value)) {
        this.setState({
          paid_minute: value,
          edited: true
        })
      }
      else {
        return;
        // notify.show("Invalid paid minute number")
      }
    }
    return value
  }

  render() {

    return (
      <div className="row college-info">
        {
          this.props.bookingCount?.length && this.getNumberOfBookingForCurrentClass() ? (
            <div className="col-12 mb-3">
              <Alert severity="info">This timetable record has current bookings attached</Alert>
            </div>
          ) : null
        }
        <div className="col-lg-6">
          <ButtonContainer label={this.props.user.is_childcare_centre ? "Select centre for this shift" : "Select campus for this class"} className="w-100 row flex-row align-items-center" >
						{this.state.class_campus && <UnstyledSelectIntroduction 
							options={
								this.props.campuses.map((campus) => {
                	return {
										value: campus._id,
										label: campus.address_line1 + (campus.suburb ? ', ' + campus.suburb : '')
									}
              })}
							id="class-campus"
							value={this.state.class_campus?._id}
							onValueChange={(e, value) => this.handleCampusChange(e, value)}
              buttonStyle={campusButtonStyle}
						/> }
						{/* <FormDropdown
              label=""
              id="class-campus"
              className="col-md-6 column1_style px-3"
              // value={this.props.state.campus-working-at}
              onChange={this.handleCampusChange}
              required
            >
              {(this.state.current_class === null) ? (<p></p>) : this.defaultCampus()}
              
            </FormDropdown> */}
            <p className="mx-2">
              <a href="/Campus"><small>Add another {this.props.user.is_childcare_centre ? " centre" : " campus"}?</small></a>
            </p>
					</ButtonContainer>

          {
            this.props.user?.is_childcare_centre 
            ? (
              <div className="w-100 row flex-column">
                <p className="px-3 font-weight-bold my-2" style={{"fontSize": "13px"}}>
                  Select Rooms & Programs
                </p>
                {
                  this.state.qualificationList?.length ? 
                  <EcecFilterAccordion
                    selectedList={this.state.selected_levels}
                    qualificationList={this.state.qualificationList}
                    onChangeCategory={(e, qua, rootID) => this.handleLevelChange(e, qua, rootID)}
                    levels={this.state.vetLevels}
                    isECEC={true}
                  /> : <Spinner small />
                }
              </div>
            ) : (
              <div className="w-100 row flex-column">
                <p className="px-3 font-weight-bold my-2" style={{"fontSize": "13px"}}>
                  Select Course/Class Type
                </p>
                {
                  this.state.qualificationList?.length ? 
                  <FilterAccordion 
                    selectedList={this.state.selected_levels}
                    qualificationList={this.state.qualificationList}
                    onChangeCategory={(e, qua, rootID) => this.handleLevelChange(e, qua, rootID)}
                    levels={this.state.vetLevels}
                    isChildcareCentre={this.props.user?.is_childcare_centre}
                  /> : <Spinner small />
                }
              </div>
            )
          }
        </div>

        <div className="col-lg-6 column2_timetable">
          <ButtonContainer label="Session" className="w-100 row flex-row" >
            <div className="col-md-3">
              <CheckableButton
                checkbox
                id="morning"
                name="session-time"
                title="morning"
                className="campus-departments-checkbox"
                onChange={this.handleSessionChange}
                checked={
                  this.state.session === "morning"
                }
              >
                AM
              </CheckableButton>
            </div>
            {
              !this.props.user?.is_childcare_centre && (
                < div className="col-md-3">
                  <CheckableButton
                    checkbox
                    id="afternoon"
                    name="session-time"
                    title="afternoon"
                    className="campus-departments-checkbox"
                    onChange={this.handleSessionChange}
                    checked={
                      this.state.session === "afternoon"
                    }
                  >
                    PM
                  </CheckableButton>
                </div>
              )
            }
            {
              !this.props.user?.is_childcare_centre && (
                < div className="col-md-3">
                  <CheckableButton
                    checkbox
                    id="evening"
                    name="session-time"
                    title="evening"
                    className="campus-departments-checkbox"
                    onChange={this.handleSessionChange}
                    checked={
                      this.state.session === "evening"
                    }
                  >
                    Eve
                  </CheckableButton>
                </div>
              )
            }
            <div className="col-md-3">
              <CheckableButton
                checkbox
                id="all_day"
                name="session-time"
                title="all_day"
                className="campus-departments-checkbox"
                onChange={this.handleSessionChange}
                checked={
                  this.state.session === "all_day"
                }
              >
                All day
              </CheckableButton>
            </div>
          </ButtonContainer>
          <div className="w-100 row flex-row">
            <div className="col-md-3 pr-1">
              <TimePicker
                label="Arrival time"
                className="timePicker-box"
                onChange={value => this.setState({ arrival_time: value, edited: true })}
                value={this.state.arrival_time}
              />
            </div>
            <div className="col-md-3 pr-1">
              <TimePicker
                label="Start time"
                className="timePicker-box"
                onChange={value => this.setState({ start_time: value, edited: true })}
                value={this.state.start_time}
              />
            </div>
            <div className="col-md-3 pr-1">
              <TimePicker
                label="Finish time"
                className="timePicker-box"
                onChange={value => this.setState({ end_time: value, edited: true })}
                value={this.state.end_time}
              />
            </div>
            {/* <div className="col-md-3" style={{ paddingLeft: '12px', paddingRight: '36px' }}>
              <FormField
                label="Paid hours"
                placeholder="No. of hours"
                id="paid_hour"
                onChange={this.handlePHchange}
                value={this.state.paid_teaching_hours == 0 ? Placeholder : this.state.paid_teaching_hours}
                required
                type="number"
              />
            </div> */}
          </div>

          <div class="row flex-row mt-5">
            <div class="col-12 col-md-3">
              <ButtonContainer label="Paid hours" className="w-100" >
                <NumberInput 
                  placeholder="Hour"
                  value={this.state?.paid_hour}
                  onValueChange={(e, value) => this.onPaidHourChange(e, value, 'hour')}
                />
              </ButtonContainer>
            </div>
            <div class="col-12 col-md-3">
              <ButtonContainer label="Paid minutes" className="w-100" >
                  <UnstyledSelectIntroduction 
                    options={[
                      { label: "0", value: 0},
                      { label: "15", value: 15},
                      { label: "30", value: 30},
                      { label: "45", value: 45}
                    ]}
                    id="class-paid-minute"
                    label="Minute"
                    value={this.state?.paid_minute}
                    onValueChange={(e, value) => this.onPaidHourChange(e, value, 'minute')}
                    buttonStyle={paidMinuteButtonStyle}
                  />
              </ButtonContainer>
            </div>

          </div>

					{/* {
						this.state.isShowVETFee || true ? (
							<ButtonContainer label="Hourly Rate" className="w-100 row flex-row" >
							<div className="col-md-6">
								<UnstyledSelectIntroduction 
									options={[
											{label: "Accept current market rate $55", value:"default"}, 
											{label: "Offer a higher rate", value:"custom"}
									]}
									value={this.state.hourly_rate_option}
									onValueChange={(e, value) => this.handleHourlyRateOptionChange(e, value)}
								/>
							</div>
							<div className="col-md-6">
							{
								this.state.hourly_rate_option === 'custom' ? (
									<div className="col-md-12">
										<TextField
											id="outlined-number"
											label="Type your hourly rate"
											type="number"
											InputLabelProps={{
												shrink: true,
											}}
											variant="standard"
											onChange={(e) => this.handleHourlyRateChange(e)}
											value={this.state.hourly_rate_number}
											InputProps={{ inputProps: { min: 55, type: "number" } }}
										/>
									</div>
								) : null
							}
							</div>
						</ButtonContainer>
						) : null
					} */}


          {/* the session for day of the week */}
          <ButtonContainer label="Days of delivery" className="w-100 row flex-row" >
            <div className="col-md-3">
              <CheckableButton
                checkbox
                id="mon"
                name="session-day"
                className="campus-departments-checkbox"
                title="Monday"
                onChange={this.handleDaysChange}
                checked={
                  this.state.days_of_delivery.includes("Monday")
                }
              >
                Mon
              </CheckableButton>
              <CheckableButton
                checkbox
                id="fri"
                name="session-day"
                className="campus-departments-checkbox"
                title="Friday"
                onChange={this.handleDaysChange}
                checked={
                  this.state.days_of_delivery.includes("Friday")
                }
              >
                Fri
              </CheckableButton>
            </div>
            < div className="col-md-3">
              <CheckableButton
                checkbox
                id="tue"
                name="session-day"
                title="Tuesday"
                className="campus-departments-checkbox"
                onChange={this.handleDaysChange}
                checked={
                  this.state.days_of_delivery.includes("Tuesday")
                }
              >
                Tue
              </CheckableButton>
              {
                !this.props.user?.is_childcare_centre && (
                  <CheckableButton
                    checkbox
                    id="sat"
                    name="session-day"
                    className="campus-departments-checkbox"
                    title="Saturday"
                    onChange={this.handleDaysChange}
                    checked={
                      this.state.days_of_delivery.includes("Saturday")
                    }
                  >
                    Sat
                  </CheckableButton>
                )
              }
            </div>
            < div className="col-md-3">
              <CheckableButton
                checkbox
                id="wed"
                name="session-day"
                className="campus-departments-checkbox"
                title="Wednesday"
                onChange={this.handleDaysChange}
                checked={
                  this.state.days_of_delivery.includes("Wednesday")
                }
              >
                Wed
              </CheckableButton>
              {
                !this.props.user?.is_childcare_centre && (
                  <CheckableButton
                    checkbox
                    id="sun"
                    name="session-day"
                    className="campus-departments-checkbox"
                    title="Sunday"
                    onChange={this.handleDaysChange}
                    checked={
                      this.state.days_of_delivery.includes("Sunday")
                    }
                  >
                    Sun
                  </CheckableButton>
                )
              }
            </div>
            < div className="col-md-3">
              <CheckableButton
                checkbox
                id="thu"
                name="session-day"
                className="campus-departments-checkbox"
                title="Thursday"
                onChange={this.handleDaysChange}
                checked={
                  this.state.days_of_delivery.includes("Thursday")
                }
              >
                Thu
              </CheckableButton>
            </div>
          </ButtonContainer>
          <div className="w-100 row flex-row">
            {/* Todo: Hourly Rate Field
            <div className="col-md-12">
            <FormField
                label="Hourly Rate"
                id="hourly_rate"
                onChange={this.handleHRchange}
                value={this.state.hourly_rate?this.state.hourly_rate:50.85}
                required
                type="number"
              />
            </ div>
            */}
          </div>
          <div className="w-100 row flex-row">
            <div className="col-md-12">
              <FormField
                // type="textarea"
                id="note_gcal"
                label={
                  this.props.user?.is_childcare_centre
                    ? "Add any permanent notes for attending first shift at this centre"
                    : "Permanent instructions/notes about textbook or students (optional)"
                }
                value={this.state.class_note}
                onChange={this.handleCNchange}
                placeholder="Enter instructions/notes"
              >
              </FormField>
            </ div>
          </div>
          <div className="w-100 row flex-row">
            <div className="col-md-6">
              <FormField
                id="campus_shortname"
                label={this.props.user?.is_childcare_centre ? "Save this shift under a nickname" : "Save this class under a nickname"}
                maxLength={7}
                required
                placeholder="Max 7 characters"
                value={this.state.reference_name == "unnamed" ? Placeholder : this.state.reference_name}
                onChange={this.handleRNchange}>
              </FormField>
            </div>
            {
              !this.props.user?.is_childcare_centre && (
                <div className="col-md-6">
                  <FormField
                    id="timetable_expire"
                    label="Set an expiry date for this class (Optional)"
                    value={this.state.expired_time}
                    onChange={this.handleExpiredTimeChange}
                    type="Date"
                    min={new Date().toISOString().split('T')[0]}
                  >
                  </FormField>
                </div>
              )
            }
          </div>
          {
            this.state.created_by && (
              <ButtonContainer label={`Created by ${
                this.getInstMember()?.email || 
                this.getInstMember()?.personnel_email } 
                on ${moment.tz(this.state.current_class.createdAt, 'Australia/Melbourne').format("DD-MM-YY")} 
                at ${moment.tz(this.state.current_class.createdAt, 'Australia/Melbourne').format("HH:mm:ss")} (Melbourne time)`} 
                className="w-100 row flex-row" >
              </ButtonContainer>
            )
          }
        </div>

        <div className="row col-md-12 pt-6">
          <div className="col-md-4 column2_timetable">
            <CancelButton
              type="button"
              // className="college_delete"
              hidden={!this.props.editclass}
              //disabled
              onClick={this.openModal}
            >
              Delete
            </CancelButton>
          </div>
          <div className="col-md-4 column2_timetable">
            <ConfirmButton
              type="submit"
              // className="college_submit"
              // hidden={!this.props.editclass}
              onClick={this.props.duplicateClass}
              // disabled={!this.state.edited}
            >
              Duplicate
            </ConfirmButton>
          </div>
          <div className="col-md-4 column2_timetable">
            <ConfirmButton
              type="submit"
              // className="college_submit"
              hidden={!this.props.editclass}
              onClick={this.handleSubmit}
              disabled={!this.state.edited}
            >
              Submit
            </ConfirmButton>
          </div>

        </div>

        <Modal
          className="confirm-delete"
          header="Do you wish to delete?"
          show={this.state.isShowing}
          onClose={this.closeModal}
        >
          <div className="row m-0">
            <div className="col-md-6">
              <CancelButton
                type="button"
                onClick={this.closeModal}
              >
                Cancel
              </CancelButton>
            </div>
            <div className="col-md-6 padding-for-mobile">
              <ConfirmButton
                type="button"
                onClick={this.handleDeleteClass}
              >
                Yes and Proceed
              </ConfirmButton>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.showUnsavedPopup}
          onClose={() => this.setShowUnsavedPopup(false)}
          header="You Have Unsaved Changes"
          className="delete-modal"
          >
          <div className="center-text">Leave without saving changes?</div>
          <div className="row mt-3">
              <div className="col-lg-6">
                  <CancelButton
                    className="mt-3"
                    onClick={() => this.setShowUnsavedPopup(false)}
                  >No</CancelButton>
              </div>
              <div className="col-lg-6">
                  <ConfirmButton
                    className="mt-3"
                    onClick={() => {
                      this.setShowUnsavedPopup(false)
                      this.swapTab(this.state.moveToTag)
                      this.setState({
                        edited: false
                      })
                    }}>Yes
                  </ConfirmButton>
              </div>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  createClass: (classObj) => dispatch(createClass(classObj)),
  deleteClass: (classObj) => dispatch(deleteClass(classObj)),
  updateClass: (class_id, newData) => dispatch(updateClass(class_id, newData))
})

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(TimetableForm);
